export { default } from "./page-ottawa";
